import { render, staticRenderFns } from "./block-add-notification.vue?vue&type=template&id=765bbdf2&scoped=true&lang=pug&"
import script from "./block-add-notification.vue?vue&type=script&lang=js&"
export * from "./block-add-notification.vue?vue&type=script&lang=js&"
import style0 from "./block-add-notification.vue?vue&type=style&index=0&id=765bbdf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bbdf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VFileInput,VRow,VTextField})
